module.exports = __webpack_public_path__ + "img/root_beer_in_a_and_w_glass.803291cf.jpg";